import * as React from "react";
import * as Immutable from "immutable";

import DiscussionContext from "./Context";
import DiscussionModel from "../models/DiscussionModel";

import translationsSK from "../translations/sk";
import translationsCS from "../translations/cs";
import Container from "./Container";
import Handler from "../handlers/Handler";
import FormHandler from "../handlers/FormHandler";
import LoadHandler from "../handlers/LoadHandler";
import SortHandler from "../handlers/SortHandler";
import OtherHandler from "../handlers/OtherHandler";
import DeleteHandler from "../handlers/DeleteHandler";
import LoginHandler from "../handlers/LoginHandler";
import RatingHandler from "../handlers/RatingHandler";
import ErrorHandler from "../handlers/ErrorHandler";
import ReplyHandler from "../handlers/ReplyHandler";
import ReportHandler from "../handlers/ReportHandler";
import BlockHandler from "../handlers/BlockHandler";
import PremiumHandler from "../handlers/PremiumHandler";
import VerifyHandler from "../handlers/VerifyHandler";

export default class Discussion extends React.Component<{
    id: number;
    project: number | null;
    locale: string;
    total: number;
    login?: string;
    verify?: string;
    premium: boolean;
    fullwidth?: boolean;
    open?: boolean;
    badges?: boolean;
}, {
    model: DiscussionModel;
}> {

    private handlers: Handler[];

    public constructor(props) {
        super(props);

        this.handlers = [
            new BlockHandler(this.dispatchDelayed.bind(this), this.fetch.bind(this)),
            new DeleteHandler(this.dispatchDelayed.bind(this), this.fetch.bind(this)),
            new ErrorHandler(this.dispatchDelayed.bind(this), this.fetch.bind(this)),
            new FormHandler(this.dispatchDelayed.bind(this), this.fetch.bind(this)),
            new LoadHandler(this.dispatchDelayed.bind(this), this.fetch.bind(this)),
            new LoginHandler(this.dispatchDelayed.bind(this), this.fetch.bind(this)),
            new PremiumHandler(this.dispatchDelayed.bind(this), this.fetch.bind(this)),
            new OtherHandler(this.dispatchDelayed.bind(this), this.fetch.bind(this)),
            new RatingHandler(this.dispatchDelayed.bind(this), this.fetch.bind(this)),
            new ReplyHandler(this.dispatchDelayed.bind(this), this.fetch.bind(this)),
            new ReportHandler(this.dispatchDelayed.bind(this), this.fetch.bind(this)),
            new SortHandler(this.dispatchDelayed.bind(this), this.fetch.bind(this)),
            new VerifyHandler(this.dispatchDelayed.bind(this), this.fetch.bind(this)),
        ];

        let model = new DiscussionModel();
        model = model.setProject(this.props.project);
        model = model.setDiscussion(this.props.id);
        model = model.setTotal(this.props.total);
        model = model.setPremium(this.props.premium);
        model = model.setLocale(this.props.locale);
        model = model.setBadges(this.props.badges !== false);
        if (this.props.login && this.props.login != "") {
            model = model.setLogin(this.props.login);
        }
        if (this.props.verify && this.props.verify != "") {
            model = model.setVerify(this.props.verify);
        }
        this.state = {model};

        this.handleHash = this.handleHash.bind(this);
    }

    public componentDidMount(): void {
        this.dispatch("init");
        if (this.props.open && !this.state.model.getDisplay()) {
            this.dispatch("display", {display: true, autofocus: false});
        }
        window.addEventListener("hashchange", this.handleHash);
    }

    public componentWillUnmount(): void {
        window.removeEventListener("hashchange", this.handleHash);
    }

    private handleHash(): void {
        if (location.hash == "#diskusia") {
            this.dispatch("display", {display: true, autofocus: true});
        }
    }

    public render(): React.ReactNode {
        return (
            <DiscussionContext.Provider value={{
                dispatch: this.dispatch.bind(this),
                translate: this.translate.bind(this),
                locale: this.props.locale,
                fullwidth: this.props.fullwidth ? true : false,
            }}>
                <Container model={this.state.model}/>
            </DiscussionContext.Provider>
        );
    }

    private dispatch(action: string, params?: any): void {
        this.setState((state) => {
            let model = state.model;
            for (let handler of this.handlers) {
                model = handler.handle(model, action, params);
            }
            return {model: model};
        });
    }

    private dispatchDelayed(action: string, params?: any, timeout: number = 0): void {
        window.setTimeout(() => {
            this.dispatch(action, params);
        }, timeout);
    }

    private fetch(method: string, params: { [key: string]: any }): Promise<{
        error?: string,
        result?: any,
    }> {
        return fetch("/ajx/discussion", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            credentials: "include",
            body: JSON.stringify({
                method: method,
                params: params,
            }),
        }).then((response) => {
            return response.json();
        });
    }

    private translate(key: string, params?: { [key: string]: string }): string {

        switch (this.props.locale) {
            default:
            case "sk":
                if (typeof (translationsSK[key]) == "string") {
                    key = translationsSK[key];
                } else {
                    console.warn("Missing translation for " + key);
                }
                break;
            case "cs":
                if (typeof (translationsCS[key]) == "string") {
                    key = translationsCS[key];
                } else {
                    console.warn("Missing translation for " + key);
                }
                break;
        }

        if (typeof (params) == "object") {
            for (let name of Object.keys(params)) {
                key = key.replace("%" + name + "%", params[name]);
            }
        }

        return key;

    }

}
